<template lang="pug">
.page
  post-form(
    :post="post"
  )
</template>

<script>
import { mapGetters } from 'vuex'
import PostForm from '@/components/post/post-form'

export default {
  name: 'edit-post',
  components: {
    PostForm,
  },
  data() {
    return {
      post: null,
    }
  },
  computed: {
    ...mapGetters(['getPost']),
  },
  created() {
    this.post = this.getPost(this.$route.params.id)
  },
}
</script>

